import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

/**
 * Retorna as transações do cliente
 */
const findAll = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/walletTransactions?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os créditos')
        })
}

/**
 * Utilizado para dar crédito ou débito a uma empresa
 */
const store = (data) => {
    return api.post('/walletTransactions', data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível cadastrar o crédito')
        })
}

/**
 * Responsável por extornar um crédito fornecido a uma empresa
 */
const reversal = (id) => {
    return api.get(`/walletTransactions/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível fazer o extorno')
        })
}

/**
 * Retorno de clientes da empresa
 */
const customers = () => {
    return api.get('/walletTransactions/customers')
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de clientes')
        })
}

/**
 * Retorna o saldo da empresa passada por parametro
 */
const balanceById = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/wallets/getbalance?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o saldo')
        })
}

/**
 * Utilizado para dar crédito ou débito a uma empresa
 */
const creditReverse = (data) => {
    return api.post('/walletTransactions/credit-reverse', data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível cadastrar o crédito/estorno')
        })
}

export default {
    findAll,
    store,
    reversal,
    customers,
    balanceById,
    creditReverse
}
